import React from 'react';
import { MTableEditField } from 'material-table';
import { UTLabel } from '@widergy/energy-ui';
import { arrayOf, string, shape, any, func } from 'prop-types';
import { onlyNumbers } from '@widergy/web-utils/lib/normalize';

import { message } from 'utils/stringUtils';

import styles from './styles.module.scss';

const CustomEditField = props => {
  const hasErrors = props.fieldErrors.includes(props.columnDef.field);
  const handleChange = values => props.onChange(props.columnDef.numeric ? onlyNumbers(values) : values);

  return (
    <div className={styles.container}>
      <MTableEditField {...props} onChange={handleChange} />
      {hasErrors && (
        <UTLabel xxsmall error>
          {message('Validations:required')}
        </UTLabel>
      )}
    </div>
  );
};

CustomEditField.propTypes = {
  fieldErrors: arrayOf(string),
  columnDef: shape(any),
  onChange: func
};

export default CustomEditField;
